(function () {
  'use strict';

  window.GBUI = window.GBUI || {};

  // Shopify's consent banner also claims the viewport bottom; the CSS lifts it above this height.
  window.GBUI.syncStickyBar = function () {
    var bar = document.querySelector('.gb-sticky-bar');
    // The PDP bar stays laid out while undocked (hidden, so it can slide in) — measure only a shown bar.
    if (!bar || bar.offsetHeight === 0 || getComputedStyle(bar).visibility === 'hidden') return;
    document.documentElement.style.setProperty('--gb-sticky-bar-h', bar.offsetHeight + 'px');
    document.documentElement.classList.add('gb-sticky-bar-live');
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.GBUI.syncStickyBar, { once: true });
  } else {
    window.GBUI.syncStickyBar();
  }
  window.addEventListener('resize', window.GBUI.syncStickyBar);

  // [data-gb-tick]: re-ink a derived number whenever its text changes (see gb-shared-ui).
  function tick(el) {
    el.classList.remove('gb-ticked');
    void el.offsetWidth;
    el.classList.add('gb-ticked');
  }
  window.GBUI.tick = tick;
  function armTicks(root) {
    (root || document).querySelectorAll('[data-gb-tick]:not([data-gb-tick-armed])').forEach(function (el) {
      el.setAttribute('data-gb-tick-armed', '');
      var last = el.textContent;
      new MutationObserver(function () {
        if (el.textContent === last) return;
        var first = !last.trim();
        last = el.textContent;
        // A script filling an empty slot on load is not a change the shopper made.
        if (!first) tick(el);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  window.GBUI.armTicks = armTicks;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { armTicks(); }, { once: true });
  } else {
    armTicks();
  }

  // The docked order bar (green + trade lists) grows when an error or a wrapped row lands in
  // it; publish its real height so the WhatsApp button and the page's end padding follow.
  function syncOrderBar() {
    var bar = document.querySelector('.gb-order');
    if (!bar) return;
    var docked = getComputedStyle(bar).position === 'fixed';
    document.documentElement.style.setProperty('--gb-order-bar-h', (docked ? bar.offsetHeight : 0) + 'px');
  }
  function armOrderBar() {
    var bar = document.querySelector('.gb-order');
    if (!bar) return;
    syncOrderBar();
    if ('ResizeObserver' in window) new ResizeObserver(syncOrderBar).observe(bar);
    window.addEventListener('resize', syncOrderBar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armOrderBar, { once: true });
  } else {
    armOrderBar();
  }

  window.GBUI.busy = function (el, label) {
    if (!el) return function () {};
    var prev = el.innerHTML;
    var width = el.offsetWidth;
    var shown = false;
    var timer = setTimeout(function () {
      shown = true;
      if (width > 0) el.style.width = width + 'px';
      el.innerHTML = '<span class="gb-spinner" aria-hidden="true"></span> ' + (label || 'Working\u2026');
    }, 400);
    return function () {
      clearTimeout(timer);
      el.style.width = '';
      if (shown && el.querySelector('.gb-spinner')) el.innerHTML = prev;
    };
  };

  if (window.GBChips) return;
  window.GBChips = {
    bind: function (container, onChange) {
      if (!container || container.dataset.gbChipsBound) return;
      container.dataset.gbChipsBound = '1';
      function chips() {
        return Array.prototype.slice.call(container.querySelectorAll('[aria-pressed]'));
      }
      function rove(target) {
        chips().forEach(function (b) { b.tabIndex = b === target ? 0 : -1; });
      }
      rove(container.querySelector('[aria-pressed="true"]') || chips()[0] || null);
      container.addEventListener('focusin', function (e) {
        var btn = e.target.closest('[aria-pressed]');
        if (btn && container.contains(btn)) rove(btn);
      });
      container.addEventListener('keydown', function (e) {
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        var list = chips().filter(function (b) { return !b.disabled; });
        var i = list.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var n;
        if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = list.length - 1;
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % list.length;
        else n = (i - 1 + list.length) % list.length;
        list[n].focus();
      });
      container.addEventListener('click', function (e) {
        var btn = e.target.closest('[aria-pressed]');
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' || !container.contains(btn)) return;
        container.querySelectorAll('[aria-pressed]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        rove(btn);
        if (onChange) onChange(btn);
      });
    },
    pressed: function (container) {
      return container ? container.querySelector('[aria-pressed="true"]') : null;
    },
    refresh: function (container) {
      if (!container) return;
      var target = container.querySelector('[aria-pressed="true"]') || container.querySelector('[aria-pressed]');
      Array.prototype.forEach.call(container.querySelectorAll('[aria-pressed]'), function (b) {
        b.tabIndex = b === target ? 0 : -1;
      });
    }
  };

  if (!window.customElements.get('gb-async-form')) {
    window.customElements.define(
      'gb-async-form',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound) return;
          var root = this;
          // A parser-blocking custom element connects before its children parse.
          if (!root.querySelector('[data-af-form]') && document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { root.connectedCallback(); }, { once: true });
            return;
          }
          this.dataset.bound = '1';
          var form = root.querySelector('[data-af-form]');
          var btn = root.querySelector('[data-af-submit]');
          var msg = root.querySelector('[data-af-msg]');
          if (!form || !btn) return;
          var okClass = root.dataset.okClass || '';
          var sending = false;
          function fields() {
            return Array.prototype.slice.call(form.querySelectorAll('input[name], select[name], textarea[name]'));
          }
          function submittable(el) {
            return (el.type !== 'radio' && el.type !== 'checkbox') || el.checked;
          }
          // An invalid pattern attribute throws under the v-flag regex engine.
          function validityOf(el) {
            try {
              return el.checkValidity();
            } catch (e) {
              return true;
            }
          }
          function errFor(el) {
            return root.querySelector('[data-err-for="' + el.name + '"]');
          }
          function toggleErr(el, errEl, show) {
            errEl.hidden = !show;
            if (show) el.setAttribute('aria-invalid', 'true');
            else el.removeAttribute('aria-invalid');
          }
          fields().forEach(function (el) {
            var errEl = errFor(el);
            if (!errEl) return;
            el.addEventListener('blur', function () { toggleErr(el, errEl, !validityOf(el)); });
            el.addEventListener('input', function () { if (validityOf(el)) toggleErr(el, errEl, false); });
          });
          var restoreBusy = null;
          // A form that stays on the page tells it what was saved, so the page can show the new facts in place.
          function saved(partial) {
            var values = {};
            fields().filter(submittable).forEach(function (el) {
              if (el.name in values) values[el.name] = [].concat(values[el.name], el.value.trim());
              else values[el.name] = el.value.trim();
            });
            root.dispatchEvent(new CustomEvent('gb-af:saved', { bubbles: true, detail: { values: values, partial: partial } }));
          }
          function fail(text) {
            sending = false;
            btn.removeAttribute('aria-disabled');
            if (restoreBusy) restoreBusy();
            if (msg) {
              if (okClass) msg.classList.remove(okClass);
              msg.textContent = text;
              msg.hidden = false;
            }
          }
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (sending) return;
            var invalid = fields().filter(function (el) { return !validityOf(el); });
            if (invalid.length > 0) {
              var anyShown = false;
              invalid.forEach(function (el) {
                var errEl = errFor(el);
                if (errEl) {
                  toggleErr(el, errEl, true);
                  anyShown = true;
                }
              });
              if (!anyShown && msg) {
                if (okClass) msg.classList.remove(okClass);
                msg.textContent = root.dataset.invalidMessage || 'Fill in the required fields.';
                msg.hidden = false;
              }
              invalid[0].focus();
              return;
            }
            sending = true;
            // A disabled element drops focus to <body>.
            btn.setAttribute('aria-disabled', 'true');
            restoreBusy = window.GBUI.busy(btn, root.dataset.sendingLabel || 'Sending…');
            if (msg) msg.hidden = true;
            var body, headers;
            if (root.dataset.encoding === 'json') {
              var obj = {};
              fields().filter(submittable).forEach(function (el) { obj[el.name] = el.value.trim(); });
              body = JSON.stringify(obj);
              headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
            } else {
              var payload = new URLSearchParams();
              fields().filter(submittable).forEach(function (el) { payload.append(el.name, el.value.trim()); });
              body = payload.toString();
              headers = { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' };
            }
            fetch(root.dataset.endpoint, { method: 'POST', headers: headers, body: body })
              .then(function (r) {
                return r
                  .json()
                  .catch(function () { return {}; })
                  .then(function (b) { return { ok: r.ok && b.ok !== false, error: b.error, warning: b.warning, reference: b.reference }; });
              })
              .then(function (res) {
                if (!res.ok) return fail(res.error || root.dataset.failMessage || 'Something went wrong. Please try again.');
                if (restoreBusy) restoreBusy();
                if (root.dataset.success === 'reveal') {
                  var hide = root.querySelector('[data-af-hide]') || form;
                  hide.hidden = true;
                  var done = root.querySelector('[data-af-done]');
                  var echo = root.querySelector('[data-gb-echo-email]');
                  var emailInput = form.querySelector('input[name="email"]');
                  if (echo && emailInput && emailInput.value.trim() !== '') echo.textContent = emailInput.value.trim();
                  var refEl = root.querySelector('[data-af-reference]');
                  if (refEl && res.reference) {
                    var refStrong = refEl.querySelector('strong');
                    if (refStrong) refStrong.textContent = res.reference;
                    refEl.hidden = false;
                  }
                  if (res.reference && emailInput) {
                    try {
                      localStorage.setItem('gb_trade_application', JSON.stringify({ ref: res.reference, email: emailInput.value.trim() }));
                    } catch (e) {}
                  }
                  if (done) {
                    done.hidden = false;
                    done.setAttribute('tabindex', '-1');
                    done.focus({ preventScroll: true });
                    done.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  }
                } else if (res.warning) {
                  sending = false;
                  btn.removeAttribute('aria-disabled');
                  if (msg) {
                    if (okClass) msg.classList.remove(okClass);
                    msg.textContent = res.warning;
                    msg.hidden = false;
                  }
                  saved(true);
                } else if (root.dataset.success === 'confirm') {
                  sending = false;
                  btn.removeAttribute('aria-disabled');
                  // Reloading before the customers/update echo lands reverts the address (docs/ENGINEERING_NOTES.md).
                  if (msg) {
                    if (okClass) msg.classList.add(okClass);
                    msg.textContent = root.dataset.savedMessage || 'Saved.';
                    msg.hidden = false;
                  }
                  saved(false);
                } else {
                  if (msg) {
                    if (okClass) msg.classList.add(okClass);
                    msg.textContent = root.dataset.savedMessage || 'Saved. Refreshing…';
                    msg.hidden = false;
                  }
                  setTimeout(function () { window.location.reload(); }, 900);
                }
              })
              .catch(function () { fail(root.dataset.failMessage || 'Network error. Please try again.'); });
          });
        }
      }
    );
  }
})();

/* Not inlined in the snippet: card mode nests the gallery in the product-card's <a>, where inline <script> source leaks into the link's textContent. */
(function () {
  if (window.__gbGalleryBound) return;
  window.__gbGalleryBound = true;
  /* Card galleries ship one slide; the rest arrive as URLs and become slides on first use. */
  function hydrate(gallery) {
    var more = gallery.getAttribute('data-gb-gallery-more');
    if (!more) return;
    var base = gallery.getAttribute('data-gb-gallery-base') || '';
    gallery.removeAttribute('data-gb-gallery-more');
    var track = gallery.querySelector('.gb-gallery__track');
    var alt = gallery.getAttribute('data-gb-gallery-alt') || '';
    more.split('|').forEach(function (src) {
      if (!src) return;
      var slide = document.createElement('div');
      slide.className = 'gb-gallery__slide';
      slide.setAttribute('data-gb-gallery-slide', '');
      slide.hidden = true;
      var img = document.createElement('img');
      img.src = base + src; img.alt = alt; img.loading = 'lazy'; img.decoding = 'async'; img.className = 'gb-gallery__img';
      slide.appendChild(img);
      track.appendChild(slide);
    });
  }
  function show(gallery, index) {
    hydrate(gallery);
    var slides = gallery.querySelectorAll('[data-gb-gallery-slide]');
    var dots = gallery.querySelectorAll('[data-gb-gallery-dot]');
    var n = slides.length;
    index = ((index % n) + n) % n;
    slides.forEach(function (s, i) { s.hidden = i !== index; });
    dots.forEach(function (d, i) { d.toggleAttribute('data-gb-active', i === index); });
    var status = gallery.querySelector('[data-gb-gallery-status]');
    if (status) status.textContent = 'Photo ' + (index + 1) + ' of ' + n;
    gallery.dataset.index = String(index);
    warm(gallery, [1, -1]);
  }
  /* A lazy image in a hidden slide never loads until shown, so every arrow press waited on the network:
     fetch and decode the slide(s) the next press can reach, `steps` away from the current one. Only on a
     signal of intent: a homepage of cards must not download photos nobody asked for. */
  function warm(gallery, steps) {
    hydrate(gallery);
    var slides = gallery.querySelectorAll('[data-gb-gallery-slide]');
    var n = slides.length;
    if (n < 2) return;
    var i = parseInt(gallery.dataset.index || '0', 10);
    steps.forEach(function (step) {
      var img = slides[(((i + step) % n) + n) % n].querySelector('img');
      if (!img || img.dataset.gbWarm) return;
      img.dataset.gbWarm = '1';
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    });
  }
  /* Pointing at (or tabbing to) an arrow warms its direction; anywhere on a page gallery warms both. */
  function intent(e) {
    var gallery = e.target.closest && e.target.closest('[data-gb-gallery]');
    if (!gallery) return;
    var arrow = e.target.closest('[data-gb-gallery-prev], [data-gb-gallery-next]');
    if (arrow) warm(gallery, [arrow.hasAttribute('data-gb-gallery-prev') ? -1 : 1]);
    else if (!gallery.classList.contains('gb-gallery--card')) warm(gallery, [1, -1]);
  }
  document.addEventListener('pointerover', intent);
  document.addEventListener('focusin', intent);
  /* A page gallery (not a product card) warms its next slide once it scrolls into view: touch has no hover. */
  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        seen.unobserve(en.target);
        warm(en.target, [1]);
      });
    });
    var observe = function () {
      document.querySelectorAll('[data-gb-gallery]:not(.gb-gallery--card)').forEach(function (g) { seen.observe(g); });
    };
    if (document.readyState === 'complete') observe();
    else window.addEventListener('load', observe, { once: true });
  }
  document.addEventListener('click', function (e) {
    var gallery = e.target.closest && e.target.closest('[data-gb-gallery]');
    if (!gallery) return;
    var handled = true;
    var i = parseInt(gallery.dataset.index || '0', 10);
    if (gallery.dataset.gbSwiped) delete gallery.dataset.gbSwiped;
    else if (e.target.closest('[data-gb-gallery-prev]')) show(gallery, i - 1);
    else if (e.target.closest('[data-gb-gallery-next]')) show(gallery, i + 1);
    else handled = false;
    if (handled) { e.preventDefault(); e.stopPropagation(); }
  });
  var swipe = null;
  document.addEventListener('pointerdown', function (e) {
    var gallery = e.target.closest && e.target.closest('[data-gb-gallery]');
    swipe = gallery ? { g: gallery, x: e.clientX, y: e.clientY } : null;
  });
  /* A touch that becomes a page scroll is cancelled, not released: drop it so a later tap can't read as a swipe. */
  document.addEventListener('pointercancel', function () { swipe = null; });
  /* A finger moving sideways is about to swipe: warm that way while the gesture finishes. */
  document.addEventListener('pointermove', function (e) {
    if (!swipe || swipe.warmed) return;
    var dx = e.clientX - swipe.x;
    if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(e.clientY - swipe.y)) return;
    swipe.warmed = true;
    warm(swipe.g, [dx < 0 ? 1 : -1]);
  });
  document.addEventListener('pointerup', function (e) {
    if (!swipe) return;
    var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y, g = swipe.g;
    swipe = null;
    if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var i = parseInt(g.dataset.index || '0', 10);
    show(g, dx < 0 ? i + 1 : i - 1);
    g.dataset.gbSwiped = '1';
    setTimeout(function () { delete g.dataset.gbSwiped; }, 300);
  });
})();
